<template>
    <div class="white_container">
        <div class="widget-container">
            <iframe :src="widget_endpoint()" style="width: 100%; height: 100%; border: 0;"></iframe>
        </div>
    </div>
</template>

<script>
    import env from '@/enviroment';
    export default {
        name: 'AlfaWidget',
        components: {
        },
        data: function () {
        return {}
        },
        computed: {},
        mounted(){},
        methods:{
            widget_endpoint(){
                return env.widget_endpoint;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .widget-container{
        padding: 30px;
        >iframe{
            min-height: 650px;
        }
    }
</style>
